export default __webpack_public_path__ + "static/media/no-image.5e1143ea.svg";